module.exports = "/_next/static/images/Retail-Solutions-7f5524af4b0da17f25ecdfa70b2f7172.jpg";